import "core-js/modules/es.array.index-of.js";
import { defineComponent } from 'vue';
export default defineComponent({
  name: "TipsAlert",
  props: {
    show: {
      type: Boolean,
      "default": false,
      required: true
    },
    text: {
      type: String,
      "default": ""
    },
    buttonText: {
      type: String,
      "default": "OK"
    },
    status: {
      type: Boolean,
      "default": true
    },
    isShowStatus: {
      type: Boolean,
      "default": false
    }
  },
  emits: ['update:show', 'confirm'],
  setup: function setup(props, context) {
    var handlerClick = function handlerClick(e) {
      context.emit("update:show", false);

      if (e.target.className.indexOf("confirm") > -1) {
        context.emit("confirm");
      }
    };

    return {
      handlerClick: handlerClick
    };
  }
});